import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import formatCurrency from 'format-currency';

import {
  BOOKING_STEP, cancel, getBookingDetail, sendGTMEvents, setStep,
  setCoinsUsedInEditingBooking, setIsEditingBooking,
  setEditBookingToken, setDingusCustomerCodeUsedInEditingBooking,
} from '../../../actions/Booking';
import { bookingCancelledEvent } from '../../../events/Booking';
import '../../../static/images/loading5.gif';
import '../../../static/less/cancellation.less';
import { getLangValue } from '../../../utils/Generic';
import DsLoadingScreen from '../../ds/atoms/loading';
import DsLoadingLabel from '../../ds/atoms/loading/loadingLabel';
import DsSection from '../../ds/molecules/DsSection';
import HotelCard from '../../ds/organism/Card/CardHotel';
import DsLabelError from '../../ds/atoms/label/labelError';
import DsLabelSucceed from '../../ds/atoms/label/labelSucceed';
import Btn from '../../ds/atoms/btn';
import DsCard from '../../ds/atoms/card';
import DsBanner from '../../ds/atoms/banner';
import DsCardInfo from '../../ds/atoms/card/cardInfo';
import DsErrorScreen from '../../ds/atoms/error/errorScreen';
import withNavigate from '../../../withNavigate'; // Importa el HOC

class Cancellation extends React.Component {
  onChangeReason = (e) => {
    this.setState({
      reason: parseInt(e.target.value, 10),
      childReason: '',
      reasonFreeText: '',
    });
  };

  onChangeChildReason = (e) => {
    this.setState({
      childReason: parseInt(e.target.value, 10),
      reasonFreeText: '',
    });
  };

  onChangeFreeText = (e) => {
    this.setState({ reasonFreeText: e.target.value });
  };

  onCancel = (e) => {
    e.preventDefault();

    this.setState({ cancelWait: true });
    const { booking } = this.state;

    this.props.dispatch(cancel(
      this.props.locator,
      booking.hotel.pk,
      booking.cli_email,
      this.state.reason,
      this.state.childReason,
      this.state.reasonFreeText,
      booking.customer_code,
      booking.status === 'PEND' ? 'REVOKE' : 'CANCEL',
    )).then((response) => {
      const cancelStatus = !response || !response.cancelled ? 'CANCELLED_ERROR' : 'CANCELLED_OK';
      this.setState({
        cancelStatus,
        cancelWait: false,
        reason: null,
        childReason: '',
        reasonFreeText: '',
      });
      const cancelEvent = bookingCancelledEvent(booking, cancelStatus);
      this.props.dispatch(sendGTMEvents([cancelEvent]));
      this.props.dispatch(setCoinsUsedInEditingBooking(0));
      this.props.dispatch(setIsEditingBooking(false));
      this.props.dispatch(setEditBookingToken(null));
      this.props.dispatch(setDingusCustomerCodeUsedInEditingBooking(null));
    });
  };

  hideCancellationReasons = () => {
    this.setState({ showReasons: false });
  };

  constructor(props) {
    super(props);
    this.state = {
      booking: null,
      loadBookingError: false,
      cancelWait: false,
      cancelStatus: 'NOT_CANCELLED',
      reason: null,
      childReason: '',
      reasonFreeText: '',
      cancellationReasons: [],
      showReasons: true,
    };
  }

  cancelBtnDisabled() {
    if (!this.state.reason) {
      return true;
    }

    const reason = this.state.cancellationReasons.find((item) => item.id === this.state.reason);
    if (reason.children.length > 0 && !this.state.childReason) {
      return true;
    }

    if (reason.free_text && this.state.reasonFreeText.length === 0) {
      return true;
    }

    if (this.state.childReason) {
      const child = reason.children.find((item) => item.id === this.state.childReason);
      if (child.free_text && this.state.reasonFreeText.length === 0) {
        return true;
      }
    }

    return false;
  }

  componentDidMount() {
    const { locator, email, lang } = this.props;
    if (!locator) {
      this.props.navigate('/');
      return;
    }
    this.props.dispatch(setStep(BOOKING_STEP.NO_AVAIL_STEP));
    this.props.dispatch(getBookingDetail(lang, locator, 'email', email)).then((response) => {
      this.setState({
        booking: response.booking,
        loadBookingError: !response.booking,
        cancellationReasons: response.cancellation_reasons,
      });
    });
  }

  render() {
    const { chain } = this.props;
    if (!this.props.locator) {
      return null;
    }
    if (!this.state.booking && !this.state.loadBookingError) {
      return (
              <DsLoadingScreen chain={chain}>
                <p>{this.context.t('Loading booking...')}</p>
              </DsLoadingScreen>
      );
    }

    if (this.state.loadBookingError) {
      return (
              <DsErrorScreen title={this.context.t('Error')}>
                {this.context.t('Sorry, we could not retrieve your booking. Please, contact the hotel.')}
              </DsErrorScreen>
      );
    }
    return this.renderBookingDetails();
  }

  renderBookingDetails() {
    const { booking, lang } = this.state;
    const email = booking.cli_email;
    const { locator } = booking;
    return (
            <DsSection
                    title={this.context.t('Booking details')}
                    bookingRefenrence={this.state.booking.locator}
            >
              {this.renderBookingSummary()}
              <div className="flex -mx-2 flex-wrap">
                <HotelCard
                        className="mb-4 md:max-w-xxs flex-grow-default mx-2 order-3 md:order-1"
                        booking={booking}
                        email={email}
                        locator={locator}
                        lang={lang}
                />
                <DsCard className="mb-8 md:mb-4 mx-2 flex-grow-default order-2">
                  {this.renderCancellationForm()}
                </DsCard>
              </div>
            </DsSection>
    );
  }

  renderBookingSummary() {
    const currency = { ...this.state.booking.currency, locale: this.props.lang };

    return (
            <DsBanner className="my-4 bg-gray-200 flex flex-wrap">
              <DsCardInfo title={this.context.t('Hotel')}>
                <span className="mr-2">
                  {this.context.t(
                    'Status',
                    null,
                    'Booking status. Confirmed, cancelled, etc.',
                  )}
                </span>
                {this.state.booking.status_display}
              </DsCardInfo>
              <DsCardInfo title={this.context.t('Email')}>
                {this.state.booking.cli_email}
              </DsCardInfo>
              {this.state.booking.amount > 0
              && this.state.booking.status !== 'PEND' ? (
                      <DsCardInfo title={this.context.t('Amount')}>
                        {formatCurrency(this.state.booking.amount, currency)}
                      </DsCardInfo>
                ) : null}
              {this.state.booking.can_cancel
              && this.state.booking.status !== 'PEND' ? (
                      <DsCardInfo title={this.context.t('Cancellation fee')}>
                        {this.state.booking.cancellation_fee > 0 ? (
                                <span className="font-bold text-status-red">
                {formatCurrency(this.state.booking.cancellation_fee, currency)}
              </span>
                        ) : (
                                <span className="CancellationFeeOk">
                {formatCurrency(this.state.booking.cancellation_fee, currency)}
              </span>
                        )}
                      </DsCardInfo>
                ) : null}
            </DsBanner>
    );
  }

  renderCancelErrorMessage() {
    return (
            <div className="CancellationKo">
              <i className="fa fa-exclamation-triangle"/>
              {this.context.t('An error happened while cancelling your booking.')}
            </div>
    );
  }

  renderCancellation() {
    const { cancelStatus, cancelWait } = this.state;
    if (cancelWait) {
      return (<DsLoadingLabel>
        {this.context.t('Loading')}...
      </DsLoadingLabel>);
    }

    if (cancelStatus === 'NOT_CANCELLED' || cancelStatus === 'CANCELLED_ERROR') {
      return (
              <form onSubmit={this.onCancel}>
                <ul className="text-sm">
                  {this.state.cancellationReasons.map((reason) => (
                          <React.Fragment key={`reason_${reason.id}`}>
                            <li className="py-1">
                              <input
                                      type="radio"
                                      name="reason"
                                      checked={this.state.reason === reason.id}
                                      onChange={this.onChangeReason}
                                      id={`reason_${reason.id}`}
                                      value={reason.id}
                                      disabled={this.state.cancelWait}
                              />
                              <label htmlFor={`reason_${reason.id}`} className="mx-1 text-sm text-gray-900">
                                {getLangValue(reason, this.props.lang, 'reason')}
                              </label>
                            </li>
                            {reason.children.length > 0 && reason.id === this.state.reason && (
                                    <li className="pb-2 ml-4">
                                      <select
                                              value={this.state.childReason}
                                              onChange={this.onChangeChildReason}
                                              disabled={this.state.cancelWait}
                                      >
                                        <option disabled value="">
                                          {getLangValue(
                                            reason,
                                            this.props.lang,
                                            'children_title',
                                          )}
                                        </option>
                                        {reason.children.map((child) => (
                                                <option key={`child_${child.id}`} value={child.id}>
                                                  {getLangValue(child, this.props.lang, 'reason')}
                                                </option>
                                        ))}
                                      </select>
                                      {this.showChildReasonInput(reason) && (
                                              <input
                                                      value={this.state.reasonFreeText}
                                                      onChange={this.onChangeFreeText}
                                                      type="text"
                                                      className="reasonFreeText"
                                                      disabled={this.state.cancelWait}
                                              />
                                      )}
                                    </li>
                            )}
                            {reason.free_text && reason.id === this.state.reason && (
                                    <li className="py-1">
                                      <p className="text-xs text-gray-700 pb-1">{reason.free_text_title}</p>
                                      <textarea
                                              type="text"
                                              /* eslint-disable max-len */
                                              className="bg-gray-100 focus:bg-opacity-50 focus:outline-none focus:shadow-inner p-1 transition duration-500 ease-in-out w-64"
                                              /* eslint-enable max-len */
                                              placeholder={this.context.t('Please, write a reason...')}
                                              rows={4}
                                              value={this.state.reasonFreeText}
                                              onChange={this.onChangeFreeText}
                                              disabled={this.state.cancelWait}
                                      />
                                    </li>
                            )}
                          </React.Fragment>
                  ))}
                </ul>
                <div className="mt-4 -mx-2">
                  <Btn variant="cancel" type="submit" className="mx-2" disabled={this.cancelBtnDisabled()}>
                    {this.context.t('Yes, cancel this booking')}
                  </Btn>
                  <Btn variant="primary" type="button" className="mx-2"
                       onClick={() => this.props.navigate('/my-booking/')}>
                    {this.context.t("No, I don't want to cancel")}
                  </Btn>
                  {cancelStatus === 'CANCELLED_ERROR' && this.renderCancelErrorMessage()}
                </div>
              </form>
      );
    }

    return (
            <DsLabelSucceed>
              {this.context.t('Booking was cancelled correctly.')}
            </DsLabelSucceed>

    );
  }

  renderCancellationForm() {
    const cancellable = this.state.booking.can_cancel;
    if (!cancellable) {
      return (
              <DsLabelError>
                {this.context.t('This booking can not be cancelled.')}
              </DsLabelError>
      );
    }
    return (
            <React.Fragment>
              <header className="capitalize mb-4">
                <h2 className="text-xl text-primary font-semibold">
                  {this.context.t('Tell us your reason for cancelling')}
                </h2>
                <p className="text-gray-700 text-base">
                  {this.context.t('This is needed to complete your cancellation')}
                </p>
              </header>
              {this.renderCancellation()}
            </React.Fragment>
    );
  }

  showChildReasonInput(reason) {
    if (!this.state.childReason) {
      return false;
    }

    if (reason.children.length === 0) {
      return false;
    }

    const childReason = reason.children.find((item) => item.id === this.state.childReason);
    return !(!childReason || !childReason.free_text);
  }
}

Cancellation.propTypes = {
  navigate: PropTypes.func.isRequired, // Prop para `navigate`
};

Cancellation.contextTypes = {
  t: PropTypes.func.isRequired,
};

// Conectar el componente con Redux
const mapStateToProps = (state) => ({
  locator: state.booking.book_locator,
  email: state.booking.book_email,
  lang: state.i18nState.lang,
  chain: state.bookingFormState.chain,
});

const ConnectedCancellation = connect(mapStateToProps)(Cancellation);

// Exportar el componente envuelto con el HOC
export default withNavigate(ConnectedCancellation);
